import React, { useEffect, useState } from 'react';
import Spinner from '../Global/Spinner';
import client from '../../api/client';
import Table from '../../layout/admin/Table';
import Stats from '../../layout/admin/Stats';
import formatDate from '../../utils/formatDate';
export default function BlogPosts() {
	const [blogPosts, setBlogPosts] = useState([]);
	const [loading, setLoading] = useState(false);

	const deleteBlogPost = async (id) => {
		try {
			setLoading(true);
			console.log('inside delete blog post');
			const { data } = await client.delete(`/blog/${id}`);
			console.log({ data });
			if (data && data.length) setBlogPosts(data.blogPosts);
			else window.location.reload();
			setLoading(false);
		} catch (err) {
			setLoading(false);
			return console.error(err);
		}
	};
	const getBlog = async () => {
		try {
			setLoading(true);
			console.log('inside get clients');
			const { data } = await client.get('/blog/all');
			console.log({ data });
			if (data) setBlogPosts(data.blogPosts);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			return console.error(err);
		}
	};
	useEffect(() => {
		getBlog();
	}, []);
	if (loading) return <Spinner />;
	return (
		<div className=''>
			<Stats
				title='Blog Posts'
				subtitle='View all blog posts'
				description='This is a list of all blog posts.'
				label='Production'
				stats={[
					{
						name: 'Blog Posts',
						value: blogPosts.length,
					},
					{
						name: 'Last Created',
						fontSize: 22,
						value: formatDate(blogPosts[0]?.createdAt, {
							monthLength: 'short',
							time: true,
							localTimezone: true,
						}),
					},
					{
						name: 'Last Title',
						value: blogPosts[0]?.title,
						fontSize: 14,
					},
				]}
			/>
			<Table
				data={blogPosts}
				title='Blog Posts'
				url='/blog'
				deleteRow={deleteBlogPost}
			/>
		</div>
	);
}
